import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import waterImg from "../../images/water-antoinne.jpg";

const WaterHeroSection = () => {
  const path = useLocation();
  const [img, setImg] = useState(waterImg);
  const [title, setTitle] = useState("Mon Eau");
  const [desc, setDesc] = useState(
    ""
  );
  useEffect(() => {
    switch (path.search) {
      case "?lifecycle":
        setTitle("Mon Eau");
        setDesc(
          ""
        );
        break;
      case "?quality":
        setTitle("La Qualité de l’Eau Potable");
        setDesc(
          "Après la polémique de 2020 sur les perturbateurs endocriniens qui ont écoulé les stocks d’eau en bouteille dans nos supermarchés en France et le Covid-19, il parait intéressant de faire un état des lieux deux ans après des nouvelles directives et loi qui ont pu être mise en place pour avoir la meilleure qualité à votre robinet. Qu’en est-il des actions d’Aquavesc ?  "
        );
        break;

      case "?result":
        setTitle("Mon Eau");
        setDesc(
          "Après la polémique de 2020 sur les perturbateurs endocriniens qui ont écoulé les stocks d’eau en bouteille dans nos supermarchés en France et le Covid-19, il parait intéressant de faire un état des lieux deux ans après des nouvelles directives et loi qui ont pu être mise en place pour avoir la meilleure qualité à votre robinet. Qu’en est-il des actions d’Aquavesc ?  "
        );
        break;

      case "?price":
        setTitle("Comment est calculé le prix de l’eau ?");
        setDesc(
          "Élaboré par l’homme dans le but de rendre l’eau apte à la consommation, Le petit cycle de l’eau a été mis au point au XIXe siècle. Il est aujourd’hui l’un des principaux indicateurs du niveau de développement d’un pays. Voici ses grandes étapes."
        );
        break;

      case "?adoucissement":
        setTitle("Mon Eau");
        setDesc(
          " "
        );

        break;
      default:
        break;
    }
  }, [path.search]);

  return (
    <>
      <div className="">
        <section
          className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
            {title}
          </h1>

          <div className="flex justify-center mt-3">
            <p className="w-full text-white ">{desc}</p>
          </div>
        </section>
      </div>
    </>
  );
};

export default WaterHeroSection;
